(function () {
  var ROOT_SELECTOR = "[data-price-by-sku-root]";
  var API_ENDPOINT = "https://intelligence-api.pleiades.solutions/api/track";

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  function getSkuFromDom() {
    var skuContainer = document.querySelector(".sku_container");
    if (skuContainer && typeof skuContainer.textContent === "string") {
      var text = skuContainer.textContent.trim();
      if (text) return text;
    }
    return "";
  }

  function buildApiUrl(storeId, sku) {
    var url = new URL(API_ENDPOINT);
    url.searchParams.set("store_id", storeId || "2");
    if (sku) url.searchParams.set("sku", sku);

    var ref = document.referrer || "";
    if (ref) url.searchParams.set("referer", ref);

    var currentPath = window.location.pathname || "";
    if (currentPath) url.searchParams.set("source_page", currentPath);

    return url.toString();
  }

  function formatCurrency(value) {
    var number = Number(value);
    if (!isFinite(number)) return "";
    try {
      return new Intl.NumberFormat(navigator.language || "en-US", {
        style: "currency",
        currency: "EUR",
      }).format(number);
    } catch (e) {
      return number.toFixed(2) + " €";
    }
  }

  function applyEstimatedDelivery(inventoryQuantity, estimatedDelivery) {
    if (!estimatedDelivery) return;
    if (Number(inventoryQuantity) > 0) return;
    var inventoryElement = document.querySelector(".product__inventory");
    if (!inventoryElement) return;
    var svgElement = inventoryElement.querySelector("svg");
    if (svgElement) {
      inventoryElement.innerHTML = "";
      inventoryElement.appendChild(svgElement);
      inventoryElement.appendChild(
        document.createTextNode(" " + estimatedDelivery)
      );
    } else {
      inventoryElement.textContent = estimatedDelivery;
    }
  }

  function resetShippingDisplay(root) {
    var shippingWrapper = root.querySelector(".price-by-sku-tracker__shipping");
    if (!shippingWrapper) return;
    var shippingCost = root.querySelector("[data-shipping-cost]");
    if (shippingCost) shippingCost.textContent = "";
    shippingWrapper.style.visibility = "hidden";
  }

  function updateShippingDisplay(root, price) {
    var shippingWrapper = root.querySelector(".price-by-sku-tracker__shipping");
    var shippingCost = root.querySelector("[data-shipping-cost]");
    if (!shippingWrapper || !shippingCost) return;
    shippingCost.textContent = price;
    shippingWrapper.style.visibility = "visible";
  }

  function fetchData(root, options) {
    var opts = options || {};
    var storeId = root.dataset.storeId || "2";
    var sku = (root.dataset.sku || "").trim();
    if (!sku) sku = getSkuFromDom();
    var inventoryQuantity = root.dataset.inventoryQuantity || "0";
    var signature = sku || "__no_sku__";
    if (!opts.force && root.dataset.lastFetched === signature) return;

    resetShippingDisplay(root);

    var url = buildApiUrl(storeId, sku);

    fetch(url, { headers: { Accept: "application/json" } })
      .then(function (response) {
        if (!response.ok) throw new Error("Network response was not ok");
        return response.json();
      })
      .then(function (data) {
        if (!data || data.error) return;

        if (typeof data.price !== "undefined") {
          var priceFormatted = formatCurrency(parseFloat(data.price));
          if (priceFormatted) updateShippingDisplay(root, priceFormatted);
        }

        if (data.estimatedDelivery) {
          applyEstimatedDelivery(inventoryQuantity, data.estimatedDelivery);
        }

        root.dataset.lastFetched = signature;
      })
      .catch(function (error) {
        console.error("Price-by-SKU tracker error:", error);
      });
  }

  function initRoot(root) {
    if (!root) return;
    if (root.__priceBySkuInit) return;
    root.__priceBySkuInit = true;
    fetchData(root, { force: true });
  }

  function initAll() {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(initRoot);
  }

  ready(initAll);

  document.addEventListener("variant:change", function (event) {
    var detail = event && event.detail ? event.detail : {};
    var variant = detail.variant || {};
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(function (root) {
      if (variant && typeof variant === "object") {
        if (variant.sku) {
          root.dataset.sku = variant.sku;
        } else {
          delete root.dataset.sku;
        }
        if (typeof variant.inventory_quantity !== "undefined") {
          root.dataset.inventoryQuantity = String(variant.inventory_quantity);
        }
      }
      fetchData(root, { force: true });
    });
  });

  document.addEventListener("variant:changed", function () {
    var roots = document.querySelectorAll(ROOT_SELECTOR);
    roots.forEach(function (root) {
      fetchData(root, { force: true });
    });
  });
})();
